import src from "IMAGE";
export default { src, width: 704, height: 1748, blurWidth: 3, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAICAYAAAA870V8AAAALElEQVR42nXMSQ4AMAhC0U+H+1+5NVGjC9k9QmABVz94rDjFHZsJOVNA5foBDOkAPyco2gkAAAAASUVORK5CYII="};
